/*
  File: {file_name}
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

/*
  File: Login.css
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

import { message, Checkbox } from "antd";
import { useState, useEffect } from "react";
import { useAuth } from "./context/AuthContext";

const Step_1_Information = () => {
  const { user } = useAuth();
  const [skipCheckbox, setSkipCheckbox] = useState(false);

  useEffect(() => {
    // Check local storage for saved preference
    const userSkipPreferences = JSON.parse(
      localStorage.getItem("userSkipPreferences") || "{}"
    );
    const userId = user?.id;
    if (userId) {
      setSkipCheckbox(true);
    }
  }, []);

  const onChange = (e: { target: { checked: any } }) => {
    const isChecked = e.target.checked;
    setSkipCheckbox(isChecked);
    const userId = user?.id; // You need to implement this function
    // Update user's skip preference in local storage
    const userSkipPreferences = JSON.parse(
      localStorage.getItem("userSkipPreferences") || "{}"
    );
    if (userId) {
      userSkipPreferences[userId] = isChecked;
      localStorage.setItem(
        "userSkipPreferences",
        JSON.stringify(userSkipPreferences)
      );
      if (isChecked) {
        message.success("Got it! You won't see this screen again");
      }
    }
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <div className="step-header">Adding a New Agent</div>
      <div className="step-header-subtext">
        Welcome! This guide will walk you through the required steps to
        successfully add a new agent to the system.
      </div>

      <h3>Step 1: Agent Details</h3>
      <p>
        In this step, you'll need to provide basic details for the new agent. If
        "enable login" is checked, the system will create a user account and a
        record for the agent. If unchecked, a user account will NOT be created.
      </p>

      <h3>Step 2: Referral</h3>
      <p>
        In this step, if you're adding a new agent and they were referred by an
        existing agent you’ll be able to select the referring agent from the
        list. If the new agent was not referred by anyone, you should select
        "House Account".
      </p>

      <h3>Step 3: Review</h3>
      <p>
        In this final step, you'll review all the information you've entered for
        accuracy. Use the process flow at the top to navigate to an area in
        order to make changes. When you’re happy with what you have, click
        'done' and that's it!
      </p>
      <div style={{ padding: "10px 0px" }}>
        <Checkbox onChange={onChange} style={{ color: "#1765ad" }}>
          I don't want to see this anymore
        </Checkbox>
      </div>
    </div>
  );
};

export default Step_1_Information;
